import { __ } from '@wordpress/i18n'
import { useContext, useState } from 'react';
import SbUtils from '../../../../Utils/SbUtils';
import SettingsScreenContext from '../../../Context/SettingsScreenContext';

const ManageProUpgrade = (props) => {
	 const {
        sbCustomizer,
        editorTopLoader,
		proLicenseMemo
    } = useContext(SettingsScreenContext);

	const [ upgradeProcessLoading, setUpgradeProcessLoading ] = useState(false);
  	const [ upgradeNewVersion, setUpgradeNewVersion ] = useState(false);
  	const [ upgradeNewVersionUrl, setUpgradeNewVersionUrl ] = useState(false);
  	const [ upgradeRemoteVersion, setUpgradeRemoteVersion ] = useState("");

	const upgradeProProLicense = () => {
		setUpgradeNewVersion(false);
		setUpgradeNewVersionUrl(false);
		setUpgradeProcessLoading(true);

		const formData = {
            action: 'sbtt_maybe_upgrade_redirect',
            license_key: sbCustomizer?.pluginSettings?.license_key
        }

		SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            (data) => { //Call Back Function
        		setUpgradeProcessLoading(false);
				if (data.success === true) {
					if (data.data.same_version === true) {
						window.location.href = data.data.url;
					} else {
						setUpgradeNewVersion(true);
						setUpgradeNewVersionUrl(data.data.url);
						setUpgradeRemoteVersion(data.data.remote_version);
					}
				}
            },
            editorTopLoader,
            null,
            null
        )
	}

	const cancelUpgrade = () => {
		setUpgradeNewVersion(false);
	}

	const printOutput = () => {
		if (proLicenseMemo?.licenseUpgradeData?.isLicenseUpgraded !== false) {
			return <>
				<div className="sb-propro-box clearfix">
					<div className="sb-protopro-upgrade-ctn">
						<div className="sb-protopro-upgrade-text">
							<strong>
								{
									__(
										"Congratulations! You have upgraded to TikTok Feed ",
										"sb-customizer"
									)
								}
								<span className="sb-protopro-upgrade-type">
									{
										SbUtils.getUpgradedProTier(proLicenseMemo?.licenseUpgradeData?.licenseUpgradedInfo)
									}
								</span>
							</strong>
							<span>
								{
									__(
									"Please update the plugin by clicking the button on the right for changes to take effect",
									"sb-customizer"
									)
								}
							</span>
						</div>
						{
							proLicenseMemo?.licenseUpgradeData?.isLicenseUpgraded && upgradeNewVersion === false &&
							(
								<button
									type="button"
									className="sb-btn sb-btn-blue sb-btn-loading sb-btn-primary"
									onClick={() => upgradeProProLicense()}
									data-loading={upgradeProcessLoading === true}
								>
									<svg
										width="16"
										height="17"
										viewBox="0 0 16 17"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12.6666 5.83332L9.99996 8.49999H12C12 9.56086 11.5785 10.5783 10.8284 11.3284C10.0782 12.0786 9.06082 12.5 7.99996 12.5C7.33329 12.5 6.68663 12.3333 6.13329 12.0333L5.15996 13.0067C6.00869 13.5468 6.99392 13.8336 7.99996 13.8333C9.41445 13.8333 10.771 13.2714 11.7712 12.2712C12.7714 11.271 13.3333 9.91448 13.3333 8.49999H15.3333L12.6666 5.83332ZM3.99996 8.49999C3.99996 7.43912 4.42139 6.42171 5.17153 5.67156C5.92168 4.92142 6.93909 4.49999 7.99996 4.49999C8.66663 4.49999 9.31329 4.66666 9.86663 4.96666L10.84 3.99332C9.99123 3.45316 9.006 3.16638 7.99996 3.16666C6.58547 3.16666 5.22892 3.72856 4.22872 4.72875C3.22853 5.72895 2.66663 7.0855 2.66663 8.49999H0.666626L3.33329 11.1667L5.99996 8.49999"
											fill="white"
										/>
									</svg>
									{__("Update Plugin", "sb-customizer")}
								</button>
							)
						}
					</div>
				</div>

				{
					upgradeNewVersion === true && upgradeNewVersionUrl !== false &&
					(
						<div className="sb-fs-boss sb-pro-newversion-popup-ctn">
							<div className="sb-pro-newversion-popup">
								<div className="sb-pro-newversion-popup-txt">
								<strong>
									{
										__(
											"The plugin will be updated to a newer version",
											"sb-customizer"
										)
									}
									<span style={{ color: "blue" }}>
										{
											upgradeRemoteVersion
										}
									</span>
								</strong>
								<span>
									{
										__(
											"You might want to backup your website before updating the plugin",
											"sb-customizer"
										)
									}
								</span>
								</div>
								<div className="sb-pro-newversion-popup-btns">
									<button
										type="button"
										className="sb-btn sb-btn-gery sb-btn-secondary sb-btn-medium"
										onClick={() => {
											cancelUpgrade()
										}}
									>
										{__("Cancel", "sb-customizer")}
									</button>
									<button
										type="button"
										className="sb-btn sb-btn-blue sb-btn-loading sb-btn-primary sb-btn-medium"
										onClick={() => {
											window.location.href = upgradeNewVersionUrl
										}}
									>
										{__("Update Anyway", "sb-customizer")}
									</button>
								</div>
							</div>
						</div>
					)
				}
			</>
		}
		return null;
	}

	return (
		<>
			 { printOutput() }
		</>
	)

}

export default ManageProUpgrade;